import api from "../lib/api";
import { Pagination, TableApiRes } from "../models/base.model";
import { Survey, SurveyEvent, SurveyEventSubmit } from "../models/survey.event.model";
import { Question } from "../models/question.model";
import { deleteConfirmDialog } from "./common.action";

export async function getSurveyEvents(): Promise<TableApiRes<SurveyEvent>> {
  const data = (
    await api<{ surveyEvents: SurveyEvent[] }>({
      url: `/survey-events`,
    })
  ).surveyEvents;
  return { data, total: data.length };
}

export async function deleteSurveyEventSubmit(surveyEventSubmitId: string, companyId: string) {
  await deleteConfirmDialog(() =>
    api({
      url: `/survey-event-submits/${surveyEventSubmitId}`,
      method: "DELETE",
      data: {
        sk: companyId,
      },
    })
  );
}

export async function getSubmitAnswers(param: { eventId: string; submitId: string }): Promise<{ answers: any; questions: Question[] }> {
  const data = await api<{ answers: any; questions: Question[] }>({
    url: `/survey-events/submits/answers`,
    data: param,
    method: "POST",
  });
  return { answers: data.answers, questions: data.questions };
}

export async function getSurveyEventSubmitsById({
  id,
  ...rest
}: {
  id: string;
} & Pagination): Promise<{
  data: SurveyEventSubmit[];
  offset?: any;
  total?: number;
}> {
  const data = await api<{
    surveyEventSubmits: SurveyEventSubmit[];
    offset?: any;
    total?: number;
  }>({
    method: "POST",
    url: `/survey-events/${id}/submits/query`,
    data: rest,
  });
  return {
    data: data.surveyEventSubmits,
    offset: data?.offset,
    ...(rest.needTotal && { total: data?.total }),
  };
}

export async function getSurveys(): Promise<TableApiRes<Survey>> {
  const data = (
    await api<{ surveys: Survey[] }>({
      url: `/surveys`,
    })
  ).surveys;
  return { data, total: data.length };
}

export async function getAllRecordsUrl(props: { id: string; polling: boolean }) {
  const data = (
    await api<{
      url: string;
    }>({
      url: `/survey-events/${props.id}/submits/download`,
      method: "POST",
    })
  ).url;
  return data;
}
